import type { IDiscountSave, ValidationSchema } from "..";

export const schemaDiscount: ValidationSchema<IDiscountSave> = {
    name: { required: true },
    lineDescription: { required: true },
    value: { required: true, number: true },
};
